module.exports = __webpack_public_path__ + "img/laundry.2dfc7ae6.svg";